import request from '@/utils/request'

/**
 * 判断是否是 JSON 格式
 * @param {*} str 需要检测的字符串
 * @returns Boolean
 */
export const isJSON = str => {
  if (!str) {
    return false
  }

  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj == 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
}

// 获取国家列表
export const getCountryList = async (apkId = '') => {
  const params = {
    country: '',
    pageSize: 200,
    pageNumber: 1,
    apkId
  }

  const { page = {} } = await request('/v1/omsFrontPageInfo', {
    method: 'GET',
    data: params
  })

  let countryList = []
  if (Array.isArray(page.result) && page.result.length) {
    countryList = page.result.map(item => {
      return {
        id: item.id,
        country: item.country
      }
    })
  }

  return countryList
}

/**
 * 获取图片名称
 * @param {*} path 图片路径
 * @returns String
 */
export const getPicName = path => {
  // eslint-disable-next-line no-useless-escape
  const reg = /([^<>/\\\|:""\*\?]+)\.\w+$/
  const newPath = path.match(reg)

  if (Array.isArray(newPath) && newPath.length > 1) {
    return newPath[1]
  }

  return ''
}


/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
 export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js